import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectNavItems } from "state/selectors/Selectors";
import { buildMenuTree } from "../../utils/utils";
import NavigationItem from "./NavigationItem";


function isSamePath(href?: string) {
  if (!href) return false;
  try {
    const here = window.location.pathname.replace(/\/+$/, "");
    const there = new URL(href, window.location.origin).pathname.replace(
      /\/+$/,
      ""
    );
    return here === there;
  } catch {
    return false;
  }
}

const Navigation: React.FC = () => {
  const items = useSelector(selectNavItems);
  const navigationItems = useMemo(() => buildMenuTree(items), [items]);
  const [idx, setIdx] = useState(0);

  React.useEffect(() => {
    const i = Math.max(
      0,
      navigationItems.findIndex((it) => isSamePath(it.Href))
    );

    setIdx(i === -1 ? 0 : i);
  }, [navigationItems]);

  React.useEffect(() => {
    setIdx(0);
  }, [navigationItems]);

  return (
    <nav className="relative !bg-[#007167] !w-full">
      <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
        <div className="relative flex h-16 items-center justify-between">
          <div className="absolute inset-y-0 left-0 flex items-center sm:hidden"></div>
          <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
            <div className="flex shrink-0 items-center"></div>
            <div className=" sm:ml-6 sm:block">
              <div className="flex space-x-4">
                {navigationItems.map((item, i) => {
                  const selected = i === idx;
                  return (
                    <>
                      <NavigationItem
                        href={item.Href}
                        itemOrder={item.ItemOrder}
                        selected={selected}
                        title={item.Title}
                        key={item.Title}
                        index={i}
                        tooltipContent=""
                        onClick={() => setIdx(i)}
                      />
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
